
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608443118101",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "6905",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M730.112 325.837h-317.03c-15.565 0-29.082 13.517-29.082 32.973 0 17.408 13.517 32.972 29.082 32.972h317.03c15.565 0 29.082-13.516 29.082-32.972 0-17.408-11.674-32.973-29.082-32.973z m0 196.403h-317.03c-15.565 0-29.082 13.517-29.082 32.973 0 17.408 13.517 32.973 29.082 32.973h317.03c15.565 0 29.082-13.517 29.082-32.973s-11.674-32.973-29.082-32.973z m0 204.186h-317.03c-15.565 0-29.082 13.516-29.082 32.972 0 17.408 13.517 32.973 29.082 32.973h317.03c15.565 0 29.082-13.517 29.082-32.973 0-17.408-11.674-32.972-29.082-32.972zM259.482 358.81a36.864 36.864 0 1 0 73.728 0 36.864 36.864 0 1 0-73.728 0zM259.482 553.37a36.864 36.864 0 1 0 73.728 0 36.864 36.864 0 1 0-73.728 0zM259.482 759.603a36.864 36.864 0 1 0 73.728 0 36.864 36.864 0 1 0-73.728 0z",
        "fill": "",
        "p-id": "6906"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M864.256 987.136H156.262c-32.972 0-58.368-27.238-58.368-58.368v-793.6c0-32.973 27.239-58.368 58.368-58.368h706.15c32.974 0 58.369 27.238 58.369 58.368v793.6c1.843 31.13-25.395 58.368-56.525 58.368z m-702.26-64.102h698.369V139.059H161.997v783.975z",
        "fill": "",
        "p-id": "6907"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M302.08 197.427c-17.408 0-31.13-13.517-31.13-31.13V49.563c0-17.408 13.517-31.13 31.13-31.13s31.13 13.517 31.13 31.13V164.25c0 19.456-13.517 33.177-31.13 33.177z m416.358 0c-17.408 0-31.13-13.517-31.13-31.13V49.563c0-17.408 13.518-31.13 31.13-31.13s31.13 13.517 31.13 31.13V164.25c1.843 19.456-13.722 33.177-31.13 33.177z",
        "fill": "",
        "p-id": "6908"
      }
    }
  ]
})
    }
  